<div class="modal-lg">
  <div class="earn-bonus-tiers">
    <div class="otpsub">
      <div class="head">
        <div style="text-align: center">
          <img
            itemprop="image"
            class="logo logo-dark mt-x1"
            alt="CoinZoom Exchange"
            src="./assets/image/icons/logo_white.svg"
            width="200"
          />
        </div>
        <span>
          <button type="button" class="close pull-right" aria-label="Close" (click)="hideModal()">X</button>
        </span>
      </div>

      <div class="tier-details">
        @if (rate.bonusRatePct === null) {
          <div class="tier-heading">
            You are currently earning the base interest rate of
            {{ zeroPadNumberForDisplay(rate.apy, 2) }}%. By staking ZOOM at the levels below you can earn more.
          </div>
        }

        @if (rate.bonusRatePct !== null) {
          <div class="tier-heading">
            You are currently earning the base interest rate of
            {{ zeroPadNumberForDisplay(rate.apy, 2) }}% plus {{ zeroPadNumberForDisplay(rate.bonusRatePct, 2) }}% extra in ZOOM.
          </div>
        }

        @if (rate.bonusRatePct === null) {
          <div class="explanation">
            For example, if you earned $100.00 USD interest at the base rate and stake enough ZOOM for 10% more, you will also receive $10
            USD in ZOOM.
          </div>
        }

        @if (rate.bonusRatePct !== null) {
          <div class="explanation">
            For example, if you earned $100.00 USD interest at the base rate, you will also receive ${{
              zeroPadNumberForDisplay(rate.bonusRatePct, 2)
            }}
            USD in ZOOM.
          </div>
        }

        <div class="position-relative">
          @if (!fullKyc) {
            <div class="position-absolute d-flex overlay justify-content-center align-items-center">
              <a [routerLink]="['/settings/kyc']" (click)="hideModal()" class="font-20 theme-sensitive">
                Complete your registration to enable bonus interest
              </a>
            </div>
          }
          <table class="table table-striped table-css table-hover tableBodyScroll">
            <thead class="thead-dark">
              <tr>
                <th class="text-right">ZOOM balance to qualify</th>
                <th class="text-right">Additional interest</th>
              </tr>
            </thead>
            <tbody>
              @for (tier of rate.bonusTiers; track tier) {
                <tr>
                  <td class="text-right">
                    <cz-currency-amount [amount]="tier.qualifyingZoomAmt" [currency]="zoomCurrency"></cz-currency-amount>
                  </td>
                  <td class="text-right">{{ tier.bonusRatePct }}%</td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <div class="tier-ctrls">
          <button type="button" class="btn btn-success" (click)="hideModal()">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>
